import EntityProperty from '@enums/EntityProperty';
import EntityType from '@enums/EntityType';
import extendEntityTextProperties from '@utils/api/extendEntityTextProperties';
import retrieveSubscribedItem from '@utils/api/retrieveSubscribedItem';
import useLibrary from '@pkg/entities/library/useLibrary';
import useDesignStore from '@/components/DesignContainer/hooks/useDesignStore';

/**
 * Assists with extending default update properties.
 */
const useExtendProperties = () => {
  const library = useLibrary();

  const updatePropertiesAttribute = (body) => {
    const { snapshot } = useDesignStore.getState();

    const entity = retrieveSubscribedItem({
      id: body.properties.uuid,
      type: body.entityType,
      library,
      entities: snapshot.entities,
    });

    if (!entity || !library) {
      return body.properties?.properties;
    }

    return extendEntityTextProperties({
      entity,
      properties: body.properties.properties,
      propertyMap: library.properties?.mapped,
    });
  };

  const handleExtendProperties = (body, designLevel) => {
    const updatedBody = {
      ...body,
    };

    // When we update the entity properties array, we want to maintain any
    // pre-existing text based property values that aren't included in updates.
    if (updatedBody?.properties?.hasOwnProperty(EntityProperty.PROPERTIES)) {
      updatedBody.properties.properties =
        updatePropertiesAttribute(updatedBody);
    }

    switch (updatedBody.entityType) {
      case EntityType.ROLE:
        // Map new roles to a group uuid if adding them from a group level.
        if (
          updatedBody.action === 'add' &&
          designLevel.type === EntityType.GROUP
        ) {
          updatedBody.properties.group_uuid =
            updatedBody.properties.group_uuid || designLevel.uuid;
        }
        return updatedBody;
      default:
        return updatedBody;
    }
  };

  return {
    extendProperties: handleExtendProperties,
  };
};

export default useExtendProperties;
